const whiteWaveSvg = encodeURIComponent(`
  <svg width="1600" height="700" viewBox="0 0 1600 700" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g stroke="#ffffff" stroke-width="1.6" opacity="0.9">
      <path d="M-120 305 C120 70 330 80 540 290 S1000 530 1240 300 S1510 40 1720 245" />
      <path d="M-120 327 C120 92 330 102 540 312 S1000 552 1240 322 S1510 62 1720 267" />
      <path d="M-120 349 C120 114 330 124 540 334 S1000 574 1240 344 S1510 84 1720 289" />
      <path d="M-120 371 C120 136 330 146 540 356 S1000 596 1240 366 S1510 106 1720 311" />
      <path d="M-120 393 C120 158 330 168 540 378 S1000 618 1240 388 S1510 128 1720 333" />
      <path d="M-120 415 C120 180 330 190 540 400 S1000 640 1240 410 S1510 150 1720 355" />
      <path d="M-120 437 C120 202 330 212 540 422 S1000 662 1240 432 S1510 172 1720 377" />
      <path d="M-120 459 C120 224 330 234 540 444 S1000 684 1240 454 S1510 194 1720 399" />
      <path d="M-120 481 C120 246 330 256 540 466 S1000 706 1240 476 S1510 216 1720 421" />
      <path d="M-120 503 C120 268 330 278 540 488 S1000 728 1240 498 S1510 238 1720 443" />
    </g>
  </svg>
`);

const accentWaveSvg = encodeURIComponent(`
  <svg width="1600" height="700" viewBox="0 0 1600 700" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g stroke="#E8A33D" stroke-width="1.7" opacity="0.9">
      <path d="M-120 255 C140 520 380 520 620 310 S1090 95 1350 280 S1560 540 1720 410" />
      <path d="M-120 279 C140 544 380 544 620 334 S1090 119 1350 304 S1560 564 1720 434" />
      <path d="M-120 303 C140 568 380 568 620 358 S1090 143 1350 328 S1560 588 1720 458" />
      <path d="M-120 327 C140 592 380 592 620 382 S1090 167 1350 352 S1560 612 1720 482" />
      <path d="M-120 351 C140 616 380 616 620 406 S1090 191 1350 376 S1560 636 1720 506" />
      <path d="M-120 375 C140 640 380 640 620 430 S1090 215 1350 400 S1560 660 1720 530" />
      <path d="M-120 399 C140 664 380 664 620 454 S1090 239 1350 424 S1560 684 1720 554" />
    </g>
  </svg>
`);

const whiteWaveBackground = `url("data:image/svg+xml,${whiteWaveSvg}")`;
const accentWaveBackground = `url("data:image/svg+xml,${accentWaveSvg}")`;

export function getPublicSiteSx(theme) {

  return {
    pageRoot: {
      minHeight: "100vh",
      position: "relative",
      overflow: "hidden",
      boxSizing: "border-box",
      color: "#ffffff",
      background:
        "radial-gradient(circle at 16% 0%, rgba(232, 163, 61, 0.14), transparent 24%), radial-gradient(circle at 82% 14%, rgba(255,255,255,0.08), transparent 18%), radial-gradient(circle at 55% 30%, rgba(232, 163, 61, 0.05), transparent 24%), linear-gradient(180deg, #070707 0%, #0d0d0d 42%, #111111 100%)",
      "& *, & *:before, & *:after": {
        boxSizing: "border-box",
      },
      "&:before": {
        content: '""',
        position: "absolute",
        inset: { xs: "-2% auto auto -18%", md: "-5% auto auto -10%" },
        width: { xs: 760, md: 1220 },
        height: { xs: 360, md: 560 },
        backgroundImage: whiteWaveBackground,
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        opacity: 0.16,
        pointerEvents: "none",
        transform: "rotate(-8deg)",
        filter: "blur(0.2px)",
      },
      "&:after": {
        content: '""',
        position: "absolute",
        inset: { xs: "40% -28% auto auto", md: "46% -14% auto auto" },
        width: { xs: 760, md: 1280 },
        height: { xs: 360, md: 580 },
        backgroundImage: accentWaveBackground,
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        opacity: 0.12,
        pointerEvents: "none",
        transform: "scaleX(-1) rotate(9deg)",
        filter: "blur(0.3px)",
      },
    },
    heroSection: {
      position: "relative",
      zIndex: 1,
      pt: { xs: 6, md: 8 },
      pb: { xs: 4, md: 5 },
      mx: "calc(-50vw + 50%)",
      px: "calc(50vw - 50%)",
      overflow: "hidden",
      "&:before": {
        content: '""',
        position: "absolute",
        inset: 0,
        background:
          "repeating-linear-gradient(0deg, transparent, transparent 3px, rgba(255,255,255,0.015) 3px, rgba(255,255,255,0.015) 4px)",
        pointerEvents: "none",
        zIndex: 0,
      },
      "&:after": {
        content: '""',
        position: "absolute",
        inset: 0,
        backgroundImage:
          "url(https://ouro-public-assets.s3.eu-west-2.amazonaws.com/home/csmap-scene-2.jpg)",
        backgroundSize: "cover",
        backgroundPosition: "center top",
        opacity: 0.12,
        filter: "blur(0.5px)",
        maskImage: "linear-gradient(to bottom, black 0%, black 82%, transparent 100%)",
        WebkitMaskImage: "linear-gradient(to bottom, black 0%, black 82%, transparent 100%)",
        pointerEvents: "none",
        zIndex: -1,
      },
    },
    subPageHeroMapBackground: {
      "&:after": {
        backgroundImage:
          "url(https://ouro-public-assets.s3.eu-west-2.amazonaws.com/home/csmap-scene-2.jpg)",
        backgroundPosition: "center",
        opacity: 0.16,
        filter: "blur(1px)",
      },
    },
    // Two-column hero layout (panel + product visual stack). Only used on the
    // homepage — other public pages render `heroPanel` directly inside
    // `heroSection` and continue to span the full width. The visual column
    // gets a slightly larger share than before (1.05/0.95 vs 1.15/0.85) so
    // the dominant telemetry card has enough room to render its text at a
    // legible size — that card is the hero's "proof", not decoration.
    heroLayout: {
      display: "grid",
      gridTemplateColumns: { xs: "1fr", lg: "minmax(0, 1.05fr) minmax(0, 0.95fr)" },
      gap: { xs: 0, lg: 3 },
      alignItems: "stretch",
    },
    // Right-hand visual column. Hidden below `lg` so the hero panel keeps the
    // full width on mobile/tablet — the stack is decorative reinforcement of
    // the value props, not a content carrier we need to surface everywhere.
    heroVisual: {
      display: { xs: "none", lg: "block" },
      position: "relative",
      overflow: "visible",
    },
    heroScoreboard: {
      width: "100%",
      maxWidth: 520,
      backgroundColor: "rgba(11, 13, 15, 0.95)",
      border: "1px solid rgba(255,255,255,0.1)",
      borderTop: "2px solid #E8A33D",
      borderRadius: "4px",
      overflow: "hidden",
      boxShadow: "0 24px 60px rgba(0,0,0,0.6)",
      fontFamily: "'JetBrains Mono', monospace",
    },
    scoreboardHeader: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      px: 2,
      py: 1.25,
      backgroundColor: "rgba(255,255,255,0.03)",
      borderBottom: "1px solid rgba(255,255,255,0.08)",
    },
    scoreboardTitle: {
      fontSize: "0.7rem",
      fontWeight: 700,
      letterSpacing: "0.1em",
      textTransform: "uppercase",
      color: "rgba(255,255,255,0.5)",
    },
    scoreboardMap: {
      fontSize: "0.65rem",
      fontWeight: 600,
      letterSpacing: "0.08em",
      textTransform: "uppercase",
      color: "rgba(255,255,255,0.4)",
    },
    scoreboardTeamRow: {
      display: "grid",
      gridTemplateColumns: "1fr auto",
      alignItems: "center",
      px: 2,
      py: 0.75,
      borderBottom: "1px solid rgba(255,255,255,0.05)",
    },
    scoreboardTeamName: {
      fontSize: "0.75rem",
      fontWeight: 700,
      letterSpacing: "0.06em",
      textTransform: "uppercase",
    },
    scoreboardPlayerRow: {
      display: "grid",
      gridTemplateColumns: "1.4fr repeat(4, 0.6fr)",
      alignItems: "center",
      px: 2,
      py: 0.6,
      borderBottom: "1px solid rgba(255,255,255,0.04)",
      fontSize: "0.72rem",
      color: "rgba(255,255,255,0.7)",
      "&:last-child": { borderBottom: "none" },
    },
    scoreboardColHeader: {
      display: "grid",
      gridTemplateColumns: "1.4fr repeat(4, 0.6fr)",
      alignItems: "center",
      px: 2,
      py: 0.5,
      fontSize: "0.6rem",
      fontWeight: 700,
      letterSpacing: "0.1em",
      textTransform: "uppercase",
      color: "rgba(255,255,255,0.35)",
      borderBottom: "1px solid rgba(255,255,255,0.06)",
    },
    scoreboardFooter: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      px: 2,
      py: 1,
      borderTop: "1px solid rgba(255,255,255,0.08)",
      backgroundColor: "rgba(232, 163, 61, 0.06)",
    },
    scoreboardFooterText: {
      fontSize: "0.68rem",
      fontWeight: 700,
      letterSpacing: "0.08em",
      textTransform: "uppercase",
      color: "#E8A33D",
    },
    heroPanel: {
      position: "relative",
      zIndex: 2,
      overflow: "hidden",
      borderRadius: "6px",
      px: { xs: 3, md: 5 },
      pt: { xs: 3, md: 4 },
      pb: { xs: 2, md: 3 },
      background:
        "linear-gradient(180deg, rgba(18,18,18,0.96) 0%, rgba(18,18,18,0.84) 100%)",
      border: "1px solid rgba(255,255,255,0.08)",
      boxShadow: "0 30px 80px rgba(0,0,0,0.34)",
      "&:before": {
        content: '""',
        position: "absolute",
        inset: "auto -10% -4% auto",
        width: { xs: 540, md: 920 },
        height: { xs: 220, md: 340 },
        backgroundImage: whiteWaveBackground,
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        opacity: 0.06,
        pointerEvents: "none",
        maskImage: "radial-gradient(ellipse at 70% 80%, black 20%, transparent 70%)",
        WebkitMaskImage: "radial-gradient(ellipse at 70% 80%, black 20%, transparent 70%)",
      },
      "&:after": {
        content: '""',
        position: "absolute",
        inset: "-16% auto auto -8%",
        width: { xs: 220, md: 360 },
        height: { xs: 220, md: 360 },
        borderRadius: "50%",
        background:
          "radial-gradient(circle, rgba(232, 163, 61, 0.12) 0%, rgba(232, 163, 61, 0.05) 38%, transparent 72%)",
        pointerEvents: "none",
        filter: "blur(16px)",
      },
    },
    homepageHeroGlassPanel: {
      maxWidth: { lg: 560, xl: 620 },
      justifySelf: "start",
      background:
        "linear-gradient(180deg, rgba(18,18,18,0.62) 0%, rgba(18,18,18,0.42) 100%)",
      backgroundColor: "rgba(255,255,255,0.035)",
      backdropFilter: "blur(14px) saturate(1.15)",
      WebkitBackdropFilter: "blur(14px) saturate(1.15)",
      border: "1px solid rgba(255,255,255,0.1)",
      boxShadow:
        "0 30px 80px rgba(0,0,0,0.28), inset 0 1px 0 rgba(255,255,255,0.04)",
    },
    eyebrow: {
      mb: 1.5,
      display: { xs: "none", lg: "block" },
      color: "#E8A33D",
      fontFamily: "'JetBrains Mono', monospace",
      fontSize: "0.72rem",
      fontWeight: 600,
      letterSpacing: "0.08em",
      textTransform: "uppercase",
    },
    heroTitle: {
      fontSize: { xs: "2.35rem", sm: "3rem", md: "4.2rem" },
      lineHeight: 0.95,
      fontWeight: 800,
      letterSpacing: "-0.02em",
      maxWidth: "16ch",
      mb: 2,
    },
    heroTitleAccent: {
      display: "block",
      color: "#E8A33D",
      fontSize: { xs: "1.4rem", sm: "1.8rem", md: "2.2rem" },
      fontWeight: 600,
      fontStyle: "italic",
      mt: 0.5,
    },
    heroSubtitle: {
      maxWidth: 720,
      color: "rgba(255,255,255,0.74)",
      fontSize: { xs: "1rem", md: "1.18rem" },
      lineHeight: 1.65,
    },
    heroSubtitleLine: {
      display: { xs: "inline", sm: "block" },
    },
    heroActions: {
      mt: { xs: 3, lg: 2.5 },
      display: "flex",
      flexWrap: "wrap",
      gap: 1.5,
      alignItems: "center",
    },
    primaryButton: {
      minHeight: 48,
      px: 2.25,
      borderRadius: "999px",
      textTransform: "none",
      fontWeight: 700,
      backgroundColor: "#E8A33D",
      color: "#0B0D0F",
      transition: "background-color 0.15s ease-in-out",
      "&:hover": {
        backgroundColor: "#F4B752",
      },
    },
    secondaryButton: {
      minHeight: 48,
      px: 2.25,
      borderRadius: "999px",
      textTransform: "none",
      fontWeight: 700,
      borderColor: "rgba(255,255,255,0.18)",
      color: "#ffffff",
      transition: "background-color 0.15s ease-in-out, border-color 0.15s ease-in-out",
      "&:hover": {
        borderColor: "rgba(255,255,255,0.34)",
        backgroundColor: "rgba(255,255,255,0.05)",
      },
    },
    steamButton: {
      minHeight: 52,
      px: 2.5,
      gap: 1.25,
      borderRadius: "999px",
      textTransform: "none",
      fontWeight: 700,
      fontSize: "1rem",
      backgroundColor: "#E8A33D",
      color: "#0B0D0F",
      boxShadow: "0 12px 28px rgba(0,0,0,0.32)",
      transition: "background-color 0.15s ease-in-out",
      "&:hover": {
        backgroundColor: "#B97A1F",
      },
    },
    steamButtonIcon: {
      width: 22,
      height: 22,
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
    },
    // Secondary auth row sits one line below the primary Steam CTA so Steam
    // visually owns the page's main call-to-action. The Google control is
    // intentionally smaller and prefixed with quiet "or sign in with Google"
    // microcopy — it's an alternative, not a competing primary action.
    secondaryAuthRow: {
      mt: 1.5,
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      gap: 1.25,
    },
    secondaryAuthLabel: {
      fontSize: "0.82rem",
      color: "rgba(255,255,255,0.5)",
      fontWeight: 500,
    },
    googleAuthSlot: {
      display: "inline-flex",
      alignItems: "center",
      "& > div": {
        borderRadius: "999px",
      },
    },
    mobileGooglePrimarySlot: {
      display: "inline-flex",
      alignItems: "center",
      maxWidth: "100%",
      "& > div": {
        maxWidth: "100%",
      },
    },
    assuranceText: {
      mt: 1.25,
      fontSize: "0.82rem",
      lineHeight: 1.5,
      color: "rgba(255,255,255,0.58)",
      maxWidth: 520,
    },
    steamOpenIdBadge: {
      mt: 1,
      display: "flex",
      alignItems: "center",
      gap: 0.5,
      fontSize: "0.78rem",
      color: "rgba(255,255,255,0.5)",
      lineHeight: 1.4,
    },
    howItWorksLink: {
      mt: { xs: 1.5, lg: 1 },
      display: "inline-block",
      fontSize: { xs: "0.9rem", lg: "0.85rem" },
      color: "rgba(255,255,255,0.62)",
      textDecoration: "none",
      fontFamily: "'Inter', system-ui, sans-serif",
      cursor: "pointer",
      "&:hover": { color: "rgba(255,255,255,0.88)" },
    },
    seeHowItWorksLink: {
      display: "inline",
      fontSize: "inherit",
      fontWeight: 600,
      color: "rgba(255,255,255,0.72)",
      textDecoration: "underline",
      textUnderlineOffset: "3px",
      textDecorationColor: "rgba(255,255,255,0.3)",
      fontFamily: "inherit",
      "&:hover": { color: "rgba(255,255,255,0.92)", textDecorationColor: "rgba(255,255,255,0.5)" },
    },
    eloTrustLine: {
      mt: { xs: 2, lg: 1.5 },
      display: "inline-flex",
      alignItems: "center",
      px: { xs: 0, lg: 1.75 },
      py: { xs: 0, lg: 0.75 },
      borderRadius: { xs: 0, lg: "999px" },
      fontSize: { xs: "0.85rem", lg: "0.88rem" },
      fontWeight: 600,
      color: "#E8A33D",
      backgroundColor: "transparent",
      border: { xs: "none", lg: "1px solid #E8A33D" },
      lineHeight: 1.4,
      transition: "background-color 0.15s ease-in-out",
      "&:hover": {
        backgroundColor: { xs: "transparent", lg: "rgba(232, 163, 61, 0.10)" },
      },
    },
    googleDemoteRow: {
      mt: 1,
    },
    googleDemoteLink: {
      display: "inline",
      background: "none",
      border: "none",
      padding: 0,
      fontSize: "0.82rem",
      color: "rgba(255,255,255,0.5)",
      cursor: "pointer",
      fontFamily: "'Inter', system-ui, sans-serif",
      textDecoration: "underline",
      textDecorationColor: "rgba(255,255,255,0.25)",
      "&:hover": { color: "rgba(255,255,255,0.75)" },
    },
    mobileNotificationCard: {
      display: { xs: "block", lg: "none" },
      mt: 4,
      borderRadius: "4px",
      overflow: "hidden",
      backgroundColor: "rgba(12,12,12,0.92)",
      border: "1px solid rgba(255,255,255,0.08)",
      boxShadow: "0 16px 40px rgba(0,0,0,0.45), 0 0 0 1px rgba(232,163,61,0.06)",
      "& img": {
        display: "block",
        width: "100%",
        height: "auto",
      },
    },
    socialStripWrap: {
      position: "relative",
      zIndex: 1,
      mt: { xs: 2, md: 3 },
    },
    socialStrip: {
      display: "grid",
      gridTemplateColumns: { xs: "1fr", md: "repeat(3, 1fr)" },
      gap: 1.5,
      p: { xs: 2, md: 2.5 },
      borderRadius: "6px",
      backgroundColor: "rgba(255,255,255,0.03)",
      border: "1px solid rgba(255,255,255,0.08)",
    },
    socialItem: {
      display: "flex",
      flexDirection: "column",
      gap: 0.75,
      px: 1.5,
      py: 1,
    },
    socialItemLabel: {
      fontFamily: "'JetBrains Mono', monospace",
      fontSize: "0.68rem",
      fontWeight: 600,
      letterSpacing: "0.08em",
      textTransform: "uppercase",
      color: "rgba(255,255,255,0.45)",
    },
    socialItemValue: {
      fontFamily: "'JetBrains Mono', monospace",
      fontSize: "1.05rem",
      fontWeight: 700,
      color: "#ffffff",
      textShadow: "0 0 12px rgba(232, 163, 61, 0.3)",
    },
    socialItemHelper: {
      fontSize: "0.85rem",
      lineHeight: 1.5,
      color: "rgba(255,255,255,0.62)",
    },
    progressTrack: {
      mt: 0.75,
      width: "100%",
      height: 6,
      borderRadius: 999,
      backgroundColor: "rgba(255,255,255,0.08)",
      overflow: "hidden",
    },
    progressFill: {
      height: "100%",
      borderRadius: 999,
      background: "linear-gradient(90deg, #B97A1F 0%, #E8A33D 100%)",
      transition: "width 0.4s ease-out",
    },
    discordChipLink: {
      mt: 0.5,
      display: "inline-flex",
      alignItems: "center",
      gap: 0.75,
      px: 1.5,
      py: 0.75,
      borderRadius: "999px",
      backgroundColor: "#E8A33D",
      color: "#0B0D0F",
      fontFamily: "'Inter', system-ui, sans-serif",
      fontWeight: 700,
      fontSize: "0.85rem",
      letterSpacing: "0.01em",
      textDecoration: "none",
      border: "1px solid #E8A33D",
      transition: "background-color 0.15s ease-in-out, border-color 0.15s ease-in-out",
      width: "fit-content",
      "&:hover": {
        backgroundColor: "#F4B752",
        borderColor: "#F4B752",
      },
    },
    regionStrip: {
      mt: 2,
      px: 2,
      py: 1.5,
      borderRadius: "4px",
      backgroundColor: "rgba(255,255,255,0.025)",
      border: "1px solid rgba(255,255,255,0.06)",
      fontSize: "0.92rem",
      lineHeight: 1.55,
      color: "rgba(255,255,255,0.7)",
    },
    regionStripLabel: {
      display: "inline-block",
      mr: 1,
      fontFamily: "'JetBrains Mono', monospace",
      fontSize: "0.72rem",
      fontWeight: 700,
      letterSpacing: "0.14em",
      textTransform: "uppercase",
      color: "#E8A33D",
    },
    regionStripTail: {
      display: "inline-block",
      ml: 0.75,
      color: "rgba(255,255,255,0.45)",
      fontStyle: "italic",
    },
    comparisonHighlightCell: {
      color: "#ffffff",
      fontWeight: 700,
    },
    statsGrid: {
      mt: 4,
      display: "grid",
      gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)" },
      gap: 1.5,
    },
    statCard: {
      p: 2.25,
      borderRadius: "4px",
      backgroundColor: "rgba(255,255,255,0.03)",
      border: "1px solid rgba(255,255,255,0.06)",
    },
    statTitle: {
      fontSize: "1rem",
      fontWeight: 700,
      mb: 0.75,
    },
    statBody: {
      fontSize: "0.92rem",
      lineHeight: 1.6,
      color: "rgba(255,255,255,0.68)",
    },
    section: {
      position: "relative",
      zIndex: 1,
      py: { xs: 4.5, md: 6.5 },
    },
    sectionWithMapBg1: {
      position: "relative",
      zIndex: 1,
      py: { xs: 4.5, md: 6.5 },
      mx: "calc(-50vw + 50%)",
      px: "calc(50vw - 50%)",
      overflow: "hidden",
      "&::before": {
        content: '""',
        position: "absolute",
        inset: 0,
        backgroundImage:
          "url(https://ouro-public-assets.s3.eu-west-2.amazonaws.com/home/csmap-scene-1.jpg)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        opacity: 0.18,
        filter: "blur(1px)",
        maskImage: "linear-gradient(to bottom, transparent 0%, black 14%, black 82%, transparent 100%)",
        WebkitMaskImage: "linear-gradient(to bottom, transparent 0%, black 14%, black 82%, transparent 100%)",
        zIndex: -1,
        pointerEvents: "none",
      },
    },
    sectionHeader: {
      mb: 3,
      maxWidth: 760,
    },
    sectionLabel: {
      mb: 1.5,
      fontFamily: "'JetBrains Mono', monospace",
      fontSize: "11px",
      fontWeight: 600,
      letterSpacing: "0.08em",
      textTransform: "uppercase",
      color: "#E8A33D",
    },
    sectionTitle: {
      fontSize: { xs: "1.7rem", md: "2.45rem" },
      fontWeight: 800,
      letterSpacing: "-0.02em",
      lineHeight: 1.1,
      mb: 1.25,
    },
    sectionCopy: {
      fontSize: { xs: "0.98rem", md: "1.06rem" },
      lineHeight: 1.7,
      color: "rgba(255,255,255,0.72)",
    },
    cardGrid: {
      display: "grid",
      gridTemplateColumns: { xs: "1fr", md: "repeat(2, 1fr)" },
      gap: 2,
    },
    featureHero: {
      display: "grid",
      gridTemplateColumns: { xs: "1fr", md: "1.1fr 0.9fr" },
      gap: { xs: 2, md: 3 },
      alignItems: "center",
      mb: 3,
      p: { xs: 2.5, md: 3.5 },
      backgroundColor: "rgba(255,255,255,0.03)",
      border: "1px solid rgba(255,255,255,0.08)",
      borderRadius: "6px",
    },
    featureHeroCopy: {
      display: "flex",
      flexDirection: "column",
    },
    featureHeroVisual: {
      borderRadius: "4px",
      overflow: "hidden",
      border: "1px solid rgba(255,255,255,0.08)",
      "& img": {
        display: "block",
        width: "100%",
        height: "auto",
      },
    },
    featureScrollRow: {
      display: "flex",
      gap: 2,
      overflowX: "auto",
      scrollSnapType: "x mandatory",
      pb: 1.5,
      mx: { xs: -2, md: 0 },
      px: { xs: 2, md: 0 },
      "&::-webkit-scrollbar": { height: 4 },
      "&::-webkit-scrollbar-track": { background: "rgba(255,255,255,0.03)" },
      "&::-webkit-scrollbar-thumb": { background: "rgba(255,255,255,0.12)", borderRadius: 999 },
    },
    featureScrollCard: {
      flex: "0 0 280px",
      scrollSnapAlign: "start",
      p: 2.5,
      backgroundColor: "rgba(255,255,255,0.03)",
      border: "1px solid rgba(255,255,255,0.08)",
      borderRadius: "6px",
      minHeight: 280,
      display: "flex",
      flexDirection: "column",
    },
    card: {
      height: "100%",
      p: 2.5,
      borderRadius: "6px",
      backgroundColor: "rgba(255,255,255,0.03)",
      border: "1px solid rgba(255,255,255,0.08)",
    },
    cardIconWrap: {
      width: 44,
      height: 44,
      borderRadius: "4px",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      mb: 1.5,
      backgroundColor: "rgba(232, 163, 61, 0.15)",
      color: "#E8A33D",
    },
    cardTitle: {
      fontSize: "1.1rem",
      fontWeight: 700,
      mb: 1,
    },
    cardBody: {
      fontSize: "0.95rem",
      lineHeight: 1.7,
      color: "rgba(255,255,255,0.68)",
    },
    stepGrid: {
      display: "grid",
      gridTemplateColumns: { xs: "1fr", md: "repeat(3, 1fr)" },
      gap: 2,
    },
    stepCard: {
      p: 2.5,
    },
    stepHeader: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 1.25,
      mb: 1.5,
    },
    stepIconWrap: {
      width: 42,
      height: 42,
      borderRadius: "4px",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "rgba(232, 163, 61, 0.12)",
      color: "#E8A33D",
      boxShadow: "inset 0 0 0 1px rgba(232, 163, 61, 0.14)",
      flexShrink: 0,
    },
    stepNumber: {
      width: 28,
      height: 28,
      mb: 1,
      borderRadius: "999px",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "transparent",
      border: "2px solid #E8A33D",
      color: "#E8A33D",
      fontFamily: "'JetBrains Mono', monospace",
      fontWeight: 700,
      fontSize: "0.75rem",
    },
    stepNumberInline: {
      width: 32,
      height: 32,
      borderRadius: "999px",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#E8A33D",
      color: "#ffffff",
      fontWeight: 800,
      fontSize: "0.9rem",
      flexShrink: 0,
    },
    stepTitle: {
      fontSize: "1.05rem",
      fontWeight: 700,
      mb: 0.9,
    },
    stepBody: {
      fontSize: "0.95rem",
      lineHeight: 1.65,
      color: "rgba(255,255,255,0.68)",
    },
    accentPanel: {
      p: { xs: 3, md: 4 },
      borderRadius: "6px",
      background:
        "linear-gradient(135deg, rgba(232, 163, 61, 0.12) 0%, rgba(232, 163, 61, 0.04) 100%)",
      border: "1px solid rgba(232, 163, 61, 0.18)",
    },
    bulletList: {
      pl: 2.5,
      m: 0,
      "& li": {
        marginBottom: theme.spacing(1),
      },
    },
    listItemText: {
      fontSize: "0.95rem",
      lineHeight: 1.65,
      color: "rgba(255,255,255,0.74)",
    },
    faqList: {
      display: "grid",
      gap: 1.5,
    },
    faqCard: {
      p: 2.25,
      borderRadius: "6px",
      backgroundColor: "rgba(255,255,255,0.03)",
      border: "1px solid rgba(255,255,255,0.08)",
    },
    faqQuestion: {
      fontSize: "1rem",
      fontWeight: 700,
      mb: 0.75,
    },
    faqAnswer: {
      fontSize: "0.95rem",
      lineHeight: 1.65,
      color: "rgba(255,255,255,0.68)",
    },
    callout: {
      mt: 5,
      p: { xs: 3, md: 4 },
      borderRadius: "6px",
      backgroundColor: "rgba(255,255,255,0.03)",
      border: "1px solid rgba(255,255,255,0.08)",
      textAlign: "center",
    },
    tableWrap: {
      overflowX: "auto",
      borderRadius: "6px",
      border: "1px solid rgba(255,255,255,0.08)",
    },
    comparisonTable: {
      width: "100%",
      borderCollapse: "collapse",
      "& th": {
        textAlign: "left",
        fontWeight: 700,
        padding: theme.spacing(2),
        backgroundColor: "rgba(255,255,255,0.03)",
        borderBottom: "1px solid rgba(255,255,255,0.08)",
        verticalAlign: "bottom",
      },
      "& td": {
        padding: theme.spacing(2),
        color: "rgba(255,255,255,0.74)",
        borderBottom: "1px solid rgba(255,255,255,0.06)",
      },
      "& tr:last-child td": {
        borderBottom: "none",
      },
    },
    tableHeadText: {
      fontSize: "0.95rem",
      fontWeight: 700,
      color: "#ffffff",
    },
    tableCellText: {
      fontSize: "0.95rem",
      lineHeight: 1.55,
      color: "rgba(255,255,255,0.74)",
    },
    notifyFormCard: {
      p: { xs: 2.5, md: 3 },
      borderRadius: "6px",
      backgroundColor: "rgba(255,255,255,0.03)",
      border: "1px solid rgba(255,255,255,0.08)",
    },
    notifyFormRow: {
      display: "flex",
      flexDirection: { xs: "column", md: "row" },
      gap: 2,
      mb: 2,
    },
    notifyFormPrivacyNote: {
      mt: 1.5,
      fontSize: "0.82rem",
      lineHeight: 1.5,
      color: "rgba(255,255,255,0.42)",
    },
    notifyFormSuccess: {
      p: { xs: 2.5, md: 3 },
      borderRadius: "6px",
      backgroundColor: "rgba(232, 163, 61, 0.08)",
      border: "1px solid rgba(232, 163, 61, 0.28)",
    },
  };
}
